var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c("PageHeader", { attrs: { "no-padding": "" } }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _vm._l(_vm.checkingData, function (item, i) {
            return _c("DataChecking", {
              key: i,
              attrs: {
                checkingMessage: item.checkingMessage,
                checkingNum: item.checkingNum,
                routerLink: item.routerLink,
                linkMessage: item.linkMessage,
                checkingArr: item.checkingArr,
              },
              model: {
                value: _vm.checkingModel,
                callback: function ($$v) {
                  _vm.checkingModel = $$v
                },
                expression: "checkingModel",
              },
            })
          }),
          _vm._v(" "),
          _c("DataChecking", {
            attrs: {
              checkingMessage: _vm.checkingCofactorMessage,
              checkingNum: _vm.checkingCofactorNum,
              routerLink: {
                name: "analytesManageError",
                props: { name: _vm.currentUserGroup.name },
              },
            },
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "Analyte List", search: "Analyte List:" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-btn",
            {
              staticStyle: { float: "right" },
              attrs: { color: "success", dark: "" },
              on: {
                click: function ($event) {
                  return _vm.addAnalyte()
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
              _vm._v(_vm._s(_vm.$t("Button.Add_Analyte")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.MasterAnalyteList,
                  pagination: _vm.pagination,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("td", { staticClass: "text-xs-left keep_space" }, [
                          _vm._v(_vm._s(props.item.DisplayName)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left keep_space" }, [
                          _vm._v(_vm._s(props.item.AnalyteName)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  to: {
                                    name: "AnalyteDetailManage",
                                    params: {
                                      analyteId: props.item.Id.toString(),
                                    },
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.View")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteAnalyte(props.item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { color: "error" },
                                  },
                                  [_vm._v("delete_forever")]
                                ),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.Remove")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800" },
          model: {
            value: _vm.addDialog,
            callback: function ($$v) {
              _vm.addDialog = $$v
            },
            expression: "addDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Add Analyte")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.addDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "AnalyteName:" },
                            model: {
                              value: _vm.newAnalyte.AnalyteName,
                              callback: function ($$v) {
                                _vm.$set(_vm.newAnalyte, "AnalyteName", $$v)
                              },
                              expression: "newAnalyte.AnalyteName",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "DisplayName:" },
                            model: {
                              value: _vm.newAnalyte.DisplayName,
                              callback: function ($$v) {
                                _vm.$set(_vm.newAnalyte, "DisplayName", $$v)
                              },
                              expression: "newAnalyte.DisplayName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "add", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                      _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800" },
          model: {
            value: _vm.delDialog,
            callback: function ($$v) {
              _vm.delDialog = $$v
            },
            expression: "delDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Delete Analyte")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.delDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("AnalyteManage.titleMsg", {
                        msg: _vm.deleteAnalyteName,
                      })
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "delete", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.agreeDelete()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("delete_forever"),
                      ]),
                      _vm._v(
                        _vm._s(_vm.$t("Button.DELETE_ANALYTE")) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          _vm.delDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              attrs: {
                color: _vm.snackColor,
                timeout: null,
                top: "",
                "auto-height": "",
              },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }